import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Modal } from 'antd';
import { Catcher } from '../../../';
import { BlockingAssignmentsTable } from './BlockingAssignmentsTable';
import { ReassignAllForm } from './ReassignAllForm';
import { useCardSetInfo } from '../../../../hooks';
import { cleanCardSetAssignments, getCardSetAssignments, refreshCardSetManage } from '../../../../middleware';
import { tB, tP } from '../../../../translate';
import Styles from './m_styles.less';

interface IManageModal {
    isOpen: boolean;
    onClose: () => void;
}

export const ManageModal: React.FC<IManageModal> = observer(({ isOpen, onClose }: IManageModal) => {
    const { id, companyId = '' } = useCardSetInfo();

    const refresh = (): void => {
        id && companyId && refreshCardSetManage(id, companyId);
    };

    useEffect(() => {
        if (isOpen && id) {
            getCardSetAssignments(id, 'future');
            getCardSetAssignments(id, 'parent_blocked');
            return cleanCardSetAssignments;
        }
    }, [isOpen, id]);

    return (
        <Modal
            title={tP('Manage Card Set')}
            open={isOpen}
            onCancel={onClose}
            wrapClassName={'modal'}
            footer={null}
            width={960}
            destroyOnClose
            cancelText={tB('Close')}
        >
            <Catcher>
                <div className={Styles.manageModal}>
                    <ReassignAllForm onDone={refresh} />
                    <BlockingAssignmentsTable scope={'future'} onChange={refresh} />
                    <BlockingAssignmentsTable scope={'parent_blocked'} onChange={refresh} />
                </div>
            </Catcher>
        </Modal>
    );
});
